import { Component, Inject, OnInit } from '@angular/core';
import { AuthenticationService } from '@ispm/user/services/authentication.service';
import { AberrationTabComponent } from '../aberration-tab/aberration-tab.component';

@Component({
  selector: 'aberration-notes-tab',
  templateUrl: './aberration-notes-tab.component.html',
  styleUrls: ['./aberration-notes-tab.component.scss']
})
export class AberrationNotesTabComponent extends AberrationTabComponent implements OnInit {

  aberrationId: string;

  constructor(
    public authService: AuthenticationService
  ) {
    super();
  }

  ngOnInit() {
    this.aberration
      .takeUntil(this.destroy$)
      .distinctUntilChanged()
      .filter(aberration => !!aberration)
      .subscribe(aberration => {
        this.aberrationId = aberration.id;
      });
  }

  onNoteAdded(data) {
    this.noteChanged.emit(data);
  }
}
